import { DependencyInjectId } from "@@/package/const/DependencyInjectId";
import { type ApplicationContextInterface } from "@@/package/application/applicationContext";
import type CreditApi from "~~/package/apis/credit/CreditApi";
import type CustomResponse from "~~/package/types/ResponseType";
import { PageModel } from "~~/package/mapper/common/model/PageModel";
import { CreditHistoryModel } from "~~/package/mapper/credit/model/CreditHistoryModel";
import type CreditPurchaseRequest from "~~/package/apis/credit/request/CreditPurchaseRequest";
import { CreditPurchaseModel } from "~~/package/mapper/credit/model/CreditPurchaseModel";

export default class CreditMapper {

    protected creditApi: CreditApi;
    constructor(context: ApplicationContextInterface) {
        this.creditApi =  context.getService<CreditApi>(DependencyInjectId.CreditApi)
    }

    public async getCreditHistory(page: number, size: number, creditTransactionType?: string[]): Promise<PageModel<CreditHistoryModel>> {
        const creditResponse: CustomResponse<PageModel<CreditHistoryModel>> = (await this.creditApi.getCreditHistory(page, size, creditTransactionType)).data;
        return PageModel.create(creditResponse.data);
    }

    public async purchaseCredits(request: CreditPurchaseRequest): Promise<CreditPurchaseModel> {
        const response: CustomResponse<CreditPurchaseModel> = (await this.creditApi.purchaseCredits(request)).data;
        return CreditPurchaseModel.create(response.data);
    }
}
